import React from 'react';
import "./Servicespage.css";
import Services from './Services';
import NavBar from '../components/Nav';
import Footer from '../components/footer';
import Servicespagesection from './Servicespagesection';
import Upperbox from '../components/Upperbox';
import ScrollTop from '../components/Scrolltop';
import Whatsapp from '../components/Whatsapp';
const IndividualServicespage = () => {
  return (
    <div>
     <Upperbox/>
      <NavBar/>
      <div className="banner-section">
      <div className="banner-overlay">
        <h1 className="banner-title">Individual Services</h1>
      </div>
    </div>
<Servicespagesection/>
<Whatsapp/>
<ScrollTop/>
    <Footer/>
    </div>
  )
}

export default IndividualServicespage;
